export default __webpack_public_path__ + "static/media/Explore.c6b235a8.png";